import { $http } from '~/boot/plugins/interceptors'

export default {
  async fetchFlags(): Promise<Record<string, boolean>> {
    const { data } = await $http.get<Record<string, boolean>>('/feature-flags')
    return data
  },
}
